import { handleErrors } from '.';

import type { ProfileFormData } from '../types/forms/profileform';
import type { PasswordFormData } from '../types/forms/passwordform';
import type { EmailChangeFormData } from '../types/forms/emailchangeform';

interface UserAPIParams {
  page?: number;
  per_page?: number;
  search?: string;
}

export const APIfetchUser = async (userId: string) => (
  window.axios.get(`/api/users/${userId}`)
    .then((response) => (response.data))
);

export const APIdeleteUser = async (userId: string) => (
  window.axios.delete(`/api/users/${userId}`)
    .then((response) => (response))
    .catch((error) => error)
);

export const APIfetchUsers = async (params: UserAPIParams = {}) => (
  window.axios.get('/api/users', { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIupdateProfile = async (id: string, data: ProfileFormData) => (
  window.axios.patch(`/api/users/${id}`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIupdatePassword = async (id: string, data: PasswordFormData) => (
  window.axios.patch(`/api/users/${id}/password`, data)
    .then((response) => (response))
    .catch((error) => { throw handleErrors(error); })
);

export const APIfetchUserShares = async (id: string, params: UserAPIParams = {}) => (
  window.axios.get(`/api/users/${id}/shares`, { params })
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIrequestEmailChange = async (data: EmailChangeFormData) => (
  window.axios.post('/api/user/email', data)
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIcancelEmailChange = async () => (
  window.axios.delete('/api/user/email')
    .then((response) => (response.data))
    .catch((error) => { throw handleErrors(error); })
);

export const APIconfirmEmailChange = async (token: string) => (
  window.axios.post('/api/email/confirm', { token })
    .then((response) => (response))
    .catch((error) => error.response)
);
